import { isNumber } from 'lodash'

// Helper functions
const valueOrDefault = (value, defaultValue) => isNumber(value) ? value : defaultValue

// Globals variables exposed from the back-end
export const gon = window.gon

// Constants
export const URGENT_ALIADA_ID = 4034
export const TIMEZONE = 'America/Mexico_City'
export const LOCALE = 'es'
export const HORIZON_DAYS = 28

export const TIME_LIMIT = 18
export const NEXT_SERVICE_DAY_BEFORE_TIME_LIMIT = valueOrDefault(window.aliada && window.aliada.DAYS_BEFORE_BOOKING_DAY, 1)
export const NEXT_SERVICE_DAY_AFTER_TIME_LIMIT = valueOrDefault(window.aliada && window.aliada.DAYS_AFTER_BOOKING_HOUR_LIMIT, 2)

export const serviceTypes = {
  WEEKLY: {
    id: '1',
    name: 'Semanal'
  },
  ONE_TIME: {
    id: '2',
    name: 'Única vez'
  },
  MULTIPLE: {
    id: '5',
    name: 'Varias veces por semana'
  },
  BIWEEKLY: {
    id: '6',
    name: 'Cada dos semanas'
  }
}

export const recurrencePeriodicity = {
  0: {
    name: 'Único',
    serviceTypeId: serviceTypes.ONE_TIME.id
  },
  7: {
    name: 'Semanal',
    serviceTypeId: serviceTypes.WEEKLY.id
  },
  14: {
    name: 'Bisemanal',
    serviceTypeId: serviceTypes.BIWEEKLY.id
  }
}

export const FACEBOOK_APP_ID = 861983977183075

export const searchStatus = {
  OK: 'ok',
  NO_RESULTS: 'no_results',
  UNAVAILABLE_MUNICIPALITY: 'unavailable_municipality'
}

export const userPreferences = {
  OFFICES: {
    slug: 'offices'
  }
}

export const products = {
  KIT_BASICO: {
    id: 1,
    name: 'kit Básico',
    price: 145,
    slug: 'kit_basico'
  },
  KIT_GENERAL: {
    id: 2,
    name: 'Kit Limpieza General',
    price: 385,
    slug: 'kit_general'
  },
  KIT_DETALLADO: {
    id: 3,
    name: 'Kit Limpieza a Detalle',
    price: 1050,
    slug: 'kit_detalle'
  }
}



// WEBPACK FOOTER //
// ./src/globals.js